import * as React from 'react';
import { cn } from '../../lib/utils';

export interface KpiStatCardProps {
  label: string;
  value: React.ReactNode;
  subtext: string;
  icon: React.ReactNode;
  /** Hex color for icon tile (e.g. #059669) */
  accentColor: string;
  className?: string;
}

/** Compact KPI tile aligned with admin dashboard home stat cards. */
export function KpiStatCard({
  label,
  value,
  subtext,
  icon,
  accentColor,
  className,
}: KpiStatCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-border bg-card px-4 py-3.5',
        'ring-1 ring-ring',
        className,
      )}
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <span className="text-[9px] font-bold tracking-wider text-muted-foreground uppercase">
          {label}
        </span>
        <div
          className="flex size-8 shrink-0 items-center justify-center rounded-lg border [&_svg]:size-4"
          style={{
            color: accentColor,
            backgroundColor: `${accentColor}14`,
            borderColor: `${accentColor}33`,
          }}
        >
          {icon}
        </div>
      </div>
      <div className="text-heading-h6 tracking-tight text-foreground tabular-nums">{value}</div>
      <p className="mt-1 text-[11px] leading-snug text-muted-foreground">{subtext}</p>
    </div>
  );
}
